import { currencyFormatter } from "../../../../../utils/formatter/formatter";

const DARK_GREEN = "#15803d";

// ícone de tendência 
const TrendingUpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={DARK_GREEN}
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 7h6v6" />
    <path d="m22 7-8.5 8.5-5-5L2 17" />
  </svg>
);

// Card "Ganho esperado"
// distância do ícone (largura + espaçamento) usada pra alinhar o texto de
// cima/baixo com o começo do valor em R$, não com o ícone
const TEXT_INDENT = 24;

const GainCard = ({ groupName, insight }) => (
  <div style={{
    border: "1px solid #cdeedb", borderRadius: "10px", backgroundColor: "#f2fbf5",
    padding: "8px 16px", minWidth: 230, display: "flex", flexDirection: "column", gap: 2,
  }}>
    <p style={{ fontSize: "10.5px", fontWeight: "700", color: "#2ea043", letterSpacing: "0.05em", marginLeft: TEXT_INDENT }}>
      GANHO ESPERADO · {groupName?.toUpperCase()}
    </p>
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <TrendingUpIcon />
      <p style={{ fontSize: "20px", fontWeight: "800", color: DARK_GREEN, margin: 0, lineHeight: 1.15 }}>
        {currencyFormatter.format(insight.expectedGain)}
      </p>
    </div>
    <p style={{ fontSize: "11.5px", color: "#5a8a6b", marginLeft: TEXT_INDENT }}>
      {/* toFixed sempre usa ponto, não depende do locale do navegador */}
      {(insight.shareOfTotalGain * 100).toFixed(1)}% do ganho total
    </p>
  </div>
);

// Card "Insight principal"
const InsightCard = ({ insight }) => (
  <div style={{
    flex: 1, borderRadius: "10px", backgroundColor: "#f6fbf8",
    border: "1.5px solid #d9f0e2",
    // faixa verde encostada na borda esquerda, igual nos cards de grupo de produto
    borderLeft: "4px solid #16a34a",
    padding: "14px 20px", display: "flex", alignItems: "center",
  }}>
    <p style={{ fontSize: "13px", color: "#333" }}>
      <strong>Insight principal:</strong> {insight.skuCount} SKUs no grupo. {insight.storesAnalyzed} lojas
      analisadas. Ganho projetado: {currencyFormatter.format(insight.expectedGain)}.
    </p>
  </div>
);

// TAGS de segmentação
const TierTags = ({ tags }) => (
  <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 14 }}>
    {tags.map(tag => tag.hasTag ? (
      <span key={tag.key} style={{
        padding: "2px 8px", borderRadius: "8px", fontSize: "11px", fontWeight: "700",
        color: tag.color,
        // "40" no final = opacidade em hexadecimal (~25%) — borda em tom mais claro que o texto
        border: `1.3px solid ${tag.color}40`,
        // "14" no final = opacidade em hexadecimal (~8%)
        background: `${tag.color}14`,
      }}>
        {tag.label}
      </span>
    ) : (
      <span key={tag.key} style={{ padding: "2px 4px", fontSize: "11px", fontWeight: "500", color: "#999" }}>
        {tag.label}
      </span>
    ))}
  </div>
);

// Cards e tags 
export const InsightHeader = ({ groupName, insight, tags }) => (
  <>
    <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
      <GainCard groupName={groupName} insight={insight} />
      <InsightCard insight={insight} />
    </div>
    <TierTags tags={tags} />
  </>
);
